import { css } from "@emotion/css"

import Anchor from "@p-ban/common/src/components/html/Anchor"

const SideBarLink = ({ href, children }: { href: string; children: string }) => {
  return (
    <div className={styles.linkWrapper}>
      <Anchor href={href} className={styles.link}>
        <span>{children}</span>
        <span> {">"}</span>
      </Anchor>
    </div>
  )
}

export default SideBarLink

const styles = {
  linkWrapper: css`
    display: flex;
    justify-content: flex-end;
    padding: 0px 6px;
  `,
  link: css`
    font-size: 11px;

    > span:first-child {
      color: #666666;
      text-decoration: underline;
    }
    > span:nth-child(2) {
      color: #f7931e;
      text-decoration: none;
    }
  `,
}
